import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import clientSlice from "./slices/clientSlice";
import activeTabSlice from "./slices/activeTabSlice";
import selectedChatSlice from "./slices/selectedChatSlice";
import userSlice, { setUserData } from "./slices/userSlice";
import categorySlice from "./slices/selectedCategorySlice";
import selectedClientSlice from "./CompanySlice/SelectedClientSlice";
import selectedServicesSlice from "./CompanySlice/SelectedServicesSlice";
import SelectionTypeSlice from "./CompanySlice/SelectionTypeSlice";
import ProductIdSlice from "./supplierSlice/productIdSlice";
import ProductSearchPage from "./supplierSlice/productSearchPageSlice";
import ServiceIdSlice from "./CompanySlice/ServiceIdSlice";
import WorkerDetailSlice from "./CompanySlice/WorkerDetailSlice";
import PackageIdSlice from "./supplierSlice/packageIdSlice";
import SearchKeys from "./slices/search_key_slice";
import translationSlice, { setCurrentLang } from "./slices/translationSlice";
import settingsSlice, { fetchSettings } from "./slices/settingSlice";
import CommonSlice from "./slices/commonSlice";
import paginationSlice from "./slices/paginationSlice";

const rootReducer = combineReducers({
  // Common
  clientTab: clientSlice,
  activeTab: activeTabSlice,
  activeChat: selectedChatSlice,
  userData: userSlice,
  selectedcategory: categorySlice,
  SearchKeysReducer: SearchKeys,
  settingsReducer: settingsSlice,
  paginationReducer: paginationSlice,
  // company slices
  selectedClientReducer: selectedClientSlice,
  seletedServicesReducer: selectedServicesSlice,
  selectionTypeReducer: SelectionTypeSlice,
  serviceIdReducer: ServiceIdSlice,
  workerDetailReducer: WorkerDetailSlice,
  // Supplier Slices
  productIdReducer: ProductIdSlice,
  packageIdReducer: PackageIdSlice,
  productSearchPageReducer: ProductSearchPage,
  translationReducer: translationSlice,
  commonReducer: CommonSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

store.dispatch(fetchSettings());

const data = JSON.parse(localStorage.getItem("user-data"));

const getTransalationLang = () => {
  let lang = localStorage.getItem("currentLang");
  store.dispatch(setCurrentLang(lang ? lang : "ro"));
};

getTransalationLang();

if (data) {
  store.dispatch(setUserData(data));
}

export default store;
